
import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { useUserProfile } from '@/hooks/useUserProfile';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useNavigate } from 'react-router-dom';

const UserProfile = () => {
  const { user } = useAuth();
  const { profile } = useUserProfile();
  const navigate = useNavigate();

  if (!user) return null;

  const getInitials = () => {
    if (profile?.prenom && profile?.nom) {
      return `${profile.prenom.charAt(0)}${profile.nom.charAt(0)}`.toUpperCase();
    }
    return user.email?.charAt(0).toUpperCase() || 'U';
  };

  const handleAccountClick = () => {
    navigate('/account');
  };

  return (
    <button 
      onClick={handleAccountClick}
      className="flex items-center space-x-2 focus:outline-none hover:opacity-80 transition-opacity"
    >
      <Avatar className="h-8 w-8 border-2 border-nautic-gold">
        <AvatarImage 
          src={profile?.photo_profil_url || ''} 
          alt="Photo de profil" 
        />
        <AvatarFallback className="bg-nautic-gold text-nautic font-semibold">
          {getInitials()}
        </AvatarFallback>
      </Avatar>
      <span className="hidden sm:inline text-white font-medium text-sm">Mon compte</span>
    </button>
  );
};

export default UserProfile;
